import { get, post } from './https';

export const GetTaxation = async ({
  page = 1,
  limit = 10,
  searchQuery = '',
  sortField = 'name',
  sortOrder = 'ASC',
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
  sortField?: string;
  sortOrder?: 'ASC' | 'DESC';
}) => {
  let url = `/api/v1/admin/tax-configs?limit=${limit}&page=${page}`;

  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  if (sortField && sortField !== 'name') {
    url += `&sortField=${sortField}`;
  }

  if (sortOrder && sortOrder !== 'ASC') {
    url += `&sortOrder=${sortOrder}`;
  }

  const response = await get(url);

  if (response.status == 200) {
    return response.data;
  } else {
    throw new Error('Failed to fetch taxation');
  }
};

export const CreateTax = async ({
  name,
  effectiveFrom,
  gst,
}: {
  name: string;
  effectiveFrom: string;
  gst: any;
}) => {
  const payload = {
    name,
    effectiveFrom,
    gst,
  };

  console.log('payload', payload);

  const response = await post('/api/v1/admin/tax-configs', payload);

  if (response.status === 201) {
    return response;
  } else {
    throw new Error(response.statusText || 'Failed to create taxation');
  }
};
